import { Routes, Route } from 'react-router-dom'
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import BackToTop from './components/BackToTop'
import ChatWidget from './components/ChatWidget'
import Home from './pages/Home'
import About from './pages/About'
import Packages from './pages/Packages'
import PackageDetail from './pages/PackageDetail'
import Blog from './pages/Blog'
import BlogDetail from './pages/BlogDetail'
import Contact from './pages/Contact'
import Services from './pages/Services'
import IslandHolidays from './pages/IslandHolidays'
import Cruises from './pages/Cruises'
import Tours from './pages/Tours'
import SportsTravel from './pages/SportsTravel'
import SkiHolidays from './pages/SkiHolidays'
import RailTravel from './pages/RailTravel'
import Flights from './pages/Flights'
import VisaSupport from './pages/VisaSupport'
import SEO from './components/SEO'
import { useFranchiseData } from './hooks/useFranchiseData'
import { buildOrganizationSchema, buildWebsiteSchema } from './utils/schema'
import { getBrandLogoUrl } from './components/BrandMark'
import AdminRedirect from './pages/AdminRedirect'

function App() {
  const { franchiseData } = useFranchiseData()
  const baseUrl = typeof window !== 'undefined' ? window.location.origin : ''
  return (
    <div className="min-h-screen bg-cream flex flex-col">
      {franchiseData && (
        <SEO
          title={`${franchiseData.name} - Travel & Holiday Packages`}
          description={franchiseData.catch_phrase}
          openGraph={{
            type: 'website',
            title: `${franchiseData.name} - Travel & Holiday Packages`,
            description: franchiseData.catch_phrase,
            image: getBrandLogoUrl(baseUrl),
            url: baseUrl,
            siteName: franchiseData.name,
          }}
          twitter={{ card: 'summary_large_image' }}
          jsonLd={[
            buildOrganizationSchema(franchiseData),
            buildWebsiteSchema(franchiseData),
          ]}
        />
      )}
      <Navbar />
      <main className="flex-grow">
        <Routes>
          <Route path="/admin/*" element={<AdminRedirect />} />
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/packages" element={<Packages />} />
          <Route path="/packages/:slug" element={<PackageDetail />} />
          <Route path="/visa-support" element={<VisaSupport />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/flights" element={<Flights />} />
          <Route path="/services/island-holidays" element={<IslandHolidays />} />
          <Route path="/services/cruises" element={<Cruises />} />
          <Route path="/services/tours" element={<Tours />} />
          <Route path="/services/sports-travel" element={<SportsTravel />} />
          <Route path="/services/ski-holidays" element={<SkiHolidays />} />
          <Route path="/services/rail-travel" element={<RailTravel />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogDetail />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </main>
      <Footer />
      <BackToTop />
      <ChatWidget />
    </div>
  )
}

export default App 